import { useMutation } from '@tanstack/react-query';
import { useBrokerResetPasswordStore } from '../state/useBrokerResetPasswordStore';
import { applicationInsights } from '../../../../../../ApplicationInsights';
import { LoginApi } from '@apply/api';

export function useBrokerResetPasswordActions() {
    const loginApi = new LoginApi.LoginApi(applicationInsights);

    const passwordResetInfo = useBrokerResetPasswordStore((s) => s.passwordResetInfo);
    const reset = useBrokerResetPasswordStore((s) => s.reset);

    const mapToSaveDto = () => ({
        password: passwordResetInfo.password ?? '',
        newPassword: passwordResetInfo.newPassword ?? '',
    });

    const saveMutation = useMutation({
        mutationFn: async () => {
            const dto = mapToSaveDto();
            return await loginApi.updatePassword(dto);
        },
    });

    return {
        save: () => saveMutation.mutate(),
        saveAsync: async () => {
            try {
                const data = await saveMutation.mutateAsync();
                return { ok: true, data };
            } catch (err: any) {
                return { ok: false, error: err };
            }
        },

        reset,
    };
}
